import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios, axios)

export default new Vuex.Store({
    state: {
        launches: [],
        missions: [],
        rockets: [],
        readyState: false
    },
    mutations: {
        SET_LAUNCHES: (state, launches) => {
            state.launches = launches
        },
        SET_NEXT_LAUNCH: (state, launch) => {
            state.nextLaunch = launch
        },
        SET_MISSIONS: (state, missions) => {
            state.missions = missions
        },
        SET_ROCKETS: (state, rockets) => {
            state.rockets = rockets
        },
        SET_READY_STATE: (state, readyState) => {
            state.readyState = true
        }
    },
    actions: {
        fetchLaunches(context, apiUrl) {

            axios.get(apiUrl)
                .then((result) => {
                    result = result.data.reverse();
                    context.commit('SET_LAUNCHES', result)
                    if (this.state.launches.length && this.state.missions.length && this.state.rockets.length) {
                        context.commit('SET_READY_STATE', true)
                    }

                }).catch(error => {
                    reject(error)
                })
        },
        fetchNextLaunch(context, apiUrl) {

            axios.get(apiUrl)
                .then((result) => {
                    result = result.data;
                    context.commit('SET_NEXT_LAUNCH', result)
                    if (this.state.launches.length && this.state.missions.length && this.state.rockets.length) {
                        context.commit('SET_READY_STATE', true)
                    }
                }).catch(error => {
                    reject(error)
                })
        },
        fetchMissions(context, apiUrl) {

            axios.get(apiUrl)
                .then(result => result.data)
                .then((result) => {
                    context.commit('SET_MISSIONS', result)
                    if (this.state.launches.length && this.state.missions.length && this.state.rockets.length) {
                        context.commit('SET_READY_STATE', true)
                    }
                    return true;
                })

        },
        fetchRockets(context, apiUrl) {

            axios.get(apiUrl)
                .then(result => result.data)
                .then((result) => {
                    context.commit('SET_ROCKETS', result)
                    if (this.state.launches.length && this.state.missions.length && this.state.rockets.length) {
                        context.commit('SET_READY_STATE', true)
                    }
                    return true;
                })


        }
    },
    getters: {
        launches: state => {
            return state.launches
        },
        missions: state => {
            return state.missions
        },
        rockets: state => {
            return state.rockets
        }
    }
})
